import React from 'react';
import { Button, SxProps, Theme } from '@mui/material';
import { buttons } from '../../../utils/theme';

interface IProps {
  id: string;
  text: string;
  disabled?: boolean;
  onClick: () => void;
  sx?: SxProps<Theme> | undefined;
}

const CancelButton: React.FunctionComponent<IProps> = ({
  id,
  text,
  disabled = false,
  onClick,
  sx
}) => {
  const getStyle = (): SxProps<Theme> => {
    let result = buttons.cancel;
    if (sx) {
      result = { ...result, ...sx };
    }
    return result;
  };
  return (
    <Button id={id} data-testid={id} sx={getStyle()} disabled={disabled} onClick={onClick}>
      {text}
    </Button>
  );
};

export default CancelButton;
